import { useEffect } from 'react';

import settings from '@/constants/constants';
import datadog from '@/providers/datadog';
import googleTagManager from '@/providers/googleTagManager';
import useFeatureFlags from './useFeatureFlags';

export default function useTrackingProviders({ ready }: { ready: boolean }) {
  const { flags } = useFeatureFlags();

  // Called when the feature flag loading state changes.
  useEffect(() => {
    if (ready) {
      datadog(flags, settings);
    }
  }, [settings, ready]);

  // Called only when settings change
  useEffect(() => {
    googleTagManager(settings);
  }, [settings]);

  return {};
}
